import {createRouter, createWebHashHistory} from 'vue-router'
import {getSession, removeSession} from "@/utils/util";

const routes = [
  {
    path: '/',
    name: 'Waymon',
    redirect: '/Home'
  },
  {
    path: '/Home',
    name: 'Home',
    component: () => import ('../views/Home.vue'),
    meta: {
      title: '首页'
    }
  }, {
    path: '/Login',
    name: 'Login',
    component: () => import('../views/Login'),
    meta: {
      title: '登录'
    }
  }, {
    path: '/Admin',
    name: 'Admin',
    component: () => import ('../views/Admin.vue'),
    meta: {
      title: '管理员',
    }
  }, {
    path: '/AdminAdd',
    name: 'AdminAdd',
    component: () => import ('../views/AdminAdd.vue'),
    meta: {
      title: '添加管理员'
    }
  }, {
    path: '/AdminEdit',
    name: 'AdminEdit',
    component: () => import ('../views/AdminEdit.vue'),
    meta: {
      title: '管理员编辑'
    }
  },
  {
    path: '/Role',
    name: 'Role',
    component: () => import ('../views/Role.vue'),
    meta: {
      title: '角色管理',
    }
  },
  {
    path: '/RoleAdd',
    name: 'RoleAdd',
    component: () => import ('../views/RoleAdd.vue'),
    meta: {
      title: '添加角色'
    }
  },
  {
    path: '/RoleEdit',
    name: 'RoleEdit',
    component: () => import ('../views/RoleEdit.vue'),
    meta: {
      title: '角色编辑'
    }
  },
  {
    path: '/Member',
    name: 'Member',
    component: () => import ('../views/Member.vue'),
    meta: {
      title: '用户列表',
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/Invite',
    name: 'Invite',
    component: () => import ('../views/Invite.vue'),
    meta: {
      title: '邀请列表',
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/MemberEdit',
    name: 'MemberEdit',
    component: () => import ('../views/MemberEdit.vue'),
    meta: {
      title: '用户编辑'
    }
  },
  {
    path: '/Fans',
    name: 'Fans',
    component: () => import ('../views/Fans.vue'),
    meta: {
      title: '关注列表',
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/Order',
    name: 'Order',
    component: () => import ('../views/Order.vue'),
    meta: {
      title: '订单管理',
    }
  },
  {
    path: '/OrderBalance',
    name: 'OrderBalance',
    component: () => import ('../views/OrderBalance.vue'),
    meta: {
      title: '分账列表',
    }
  },
  {
    path: '/OrderStatic',
    name: 'OrderStatic',
    component: () => import ('../views/OrderStatic.vue'),
    meta: {
      title: '数据统计',
    }
  },
  {
    path: '/Separate',
    name: 'Separate',
    component: () => import ('../views/Separate.vue'),
    meta: {
      title: '分账管理',
    }
  },
  {
    path: '/Refund',
    name: 'Refund',
    component: () => import ('../views/Refund.vue'),
    meta: {
      title: '退款列表',
    }
  },
  {
    path: '/BusinessIncome',
    name: 'BusinessIncome',
    component: () => import ('../views/BusinessIncome.vue'),
    meta: {
      title: '商家收益',
    }
  },
  {
    path: '/PromoteIncome',
    name: 'PromoteIncome',
    component: () => import ('../views/PromoteIncome.vue'),
    meta: {
      title: '推广收益',
    }
  },
  {
    path: '/Auth',
    name: 'Auth',
    component: () => import ('../views/Auth.vue'),
    meta: {
      title: '实名认证',
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/RealName',
    name: 'RealName',
    component: () => import ('../views/RealName.vue'),
    meta: {
      title: '实名认证',
    }
  },
  {
    path: '/Business',
    name: 'Business',
    component: () => import ('../views/Business.vue'),
    meta: {
      title: '商家列表',
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/BusinessEdit',
    name: 'BusinessEdit',
    component: () => import ('../views/BusinessEdit.vue'),
    meta: {
      title: '商家编辑',
    }
  },
  {
    path: '/BusinessRealName',
    name: 'BusinessRealName',
    component: () => import ('../views/BusinessRealName.vue'),
    meta: {
      title: '商家实名认证',
    }
  },
  {
    path: '/Apply',
    name: 'Apply',
    component: () => import ('../views/Apply.vue'),
    meta: {
      title: '商家申请',
    }
  },
  {
    path: '/Affiliation',
    name: 'Affiliation',
    component: () => import ('../views/Affiliation.vue'),
    meta: {
      title: '挂靠申请',
    }
  },
  {
    path: '/BusinessFans',
    name: 'BusinessFans',
    component: () => import ('../views/BusinessFans.vue'),
    meta: {
      title: '粉丝列表',
    }
  },
  {
    path: '/Material',
    name: 'Material',
    component: () => import ('../views/Material.vue'),
    meta: {
      title: '资料列表',
    }
  },
  {
    path: '/Payment',
    name: 'Payment',
    component: () => import ('../views/Payment.vue'),
    meta: {
      title: '支付管理',
    }
  },
  {
    path: '/System',
    name: 'System',
    component: () => import ('../views/System.vue'),
    meta: {
      title: '系统设置'
    }
  },
  {
    path: '/SystemAdd',
    name: 'SystemAdd',
    component: () => import ('../views/SystemAdd.vue'),
    meta: {
      title: '系统设置'
    }
  },
  {
    path: '/Notice',
    name: 'Notice',
    component: () => import ('../views/Notice.vue'),
    meta: {
      title: '公告列表',
    }
  },{
    path: '/NoticeEdit',
    name: 'NoticeEdit',
    component: () => import ('../views/NoticeEdit.vue'),
    meta: {
      title: '公告列表',
    }
  },{
    path: '/NoticeAdd',
    name: 'NoticeAdd',
    component: () => import ('../views/NoticeAdd.vue'),
    meta: {
      title: '添加公告',
    }
  },
  {
    path: '/Message',
    name: 'Message',
    component: () => import ('../views/Message.vue'),
    meta: {
      title: '通知列表',
    }
  },{
    path: '/MessageAdd',
    name: 'MessageAdd',
    component: () => import ('../views/MessageAdd.vue'),
    meta: {
      title: '新增通知',
    }
  },{
    path: '/Banner',
    name: 'Banner',
    component: () => import ('../views/Banner.vue'),
    meta: {
      title: '轮播图列表',
    }
  },{
    path: '/BannerAdd',
    name: 'BannerAdd',
    component: () => import ('../views/BannerAdd.vue'),
    meta: {
      title: '添加轮播图',
    }
  },{
    path: '/BannerEdit',
    name: 'BannerEdit',
    component: () => import ('../views/BannerEdit.vue'),
    meta: {
      title: '轮播图编辑',
    }
  },{
    path: '/Balance',
    name: 'Balance',
    component: () => import ('../views/Balance.vue'),
    meta: {
      title: '资金明细',
    }
  },{
    path: '/Wechat',
    name: 'Wechat',
    component: () => import ('../views/Wechat.vue'),
    meta: {
      title: '微信授权',
    }
  },{
    path: '/WechatAdd',
    name: 'WechatAdd',
    component: () => import ('../views/WechatAdd.vue'),
    meta: {
      title: '新增微信',
    }
  },{
    path: '/WechatEdit',
    name: 'WechatEdit',
    component: () => import ('../views/WechatEdit.vue'),
    meta: {
      title: '微信编辑',
    }
  },{
    path: '/Report',
    name: 'Report',
    component: () => import ('../views/Report.vue'),
    meta: {
      title: '投诉列表',
      keepAlive: true // 需要缓存
    }
  },{
    path: '/Help',
    name: 'Help',
    component: () => import ('../views/Help.vue'),
    meta: {
      title: '帮助中心',
    }
  },{
    path: '/HelpAdd',
    name: 'HelpAdd',
    component: () => import ('../views/HelpAdd.vue'),
    meta: {
      title: '帮助中心-添加',
    }
  },{
    path: '/HelpEdit',
    name: 'HelpEdit',
    component: () => import ('../views/HelpEdit.vue'),
    meta: {
      title: '帮助中心-编辑',
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = getSession('token')
  if (token) { //已经登录
    document.title = to.meta.title
    next()
  } else { // 什么都没有 去授权
    if (to.name !== "Login") {
      next('/Login')
    } else {
      next()
    }
  }
})

export default router
